import React from 'react';
import { aboutContent } from '../../content/about-content';
import { PillarCard } from './infographics';

/**
 * Five Pillars Section
 *
 * Displays the five messaging pillars of the LRB brand.
 */
const FivePillarsSection = React.forwardRef(({ id = 'pillars' }, ref) => {
  const { fivePillars } = aboutContent;

  return (
    <section id={id} ref={ref} className="about-section">
      <header className="about-section__header">
        <h2 className="about-section__title">
          <svg className="about-section__title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
          {fivePillars.title}
        </h2>
        <p className="about-section__subtitle">{fivePillars.intro}</p>
      </header>

      <div className="pillars-grid">
        {fivePillars.pillars.map((pillar) => (
          <PillarCard
            key={pillar.id}
            title={pillar.title}
            tagline={pillar.tagline}
            description={pillar.description}
            icon={pillar.icon}
            color={pillar.color}
          />
        ))}
      </div>
    </section>
  );
});

FivePillarsSection.displayName = 'FivePillarsSection';

export default FivePillarsSection;
